export var VISUAL_EXERCISE = 'VisualExercise';
export var EXPORTED_EXERCISES = [VISUAL_EXERCISE];